import React from "react";
import { Link } from "react-router-dom";
import "../../assets/games.css";
const games = [
  {
    event: "Pangos All-South Frosh/Soph Camp",
    team1: "Top 30 Black",
    team2: "Top 30 White",
    date: "10/6/2024",
    location: "Duncanville , Texas",
    score: "83-73",
    winner: "Top 30 Black",
    id: "top_30_black_vs_top_30_white",
  },
];
const GameList = () => {
  return (
    <div className="game-list">
      <div className="game-header">
        <span>EVENT</span>
        <span>DATE</span>
        <span>TEAM 1</span>
        <span>TEAM 2</span>
        <span>SCORE</span>
        <span>Winner</span>
        <span>LOCATION</span>
      </div>
      {games.map((game) => (
        <Link to={`/game/${game.id}`} key={game.id} className="game-card-link">
          <div className="game-row">
            <span className="game-event">
              <strong className="game-label">Event:</strong> {game.event}
            </span>
            <span className="game-date">
              <strong className="game-label">Date:</strong> {game.date}
            </span>
            <span className="game-team">
              <strong className="game-label">Team 1:</strong> {game.team1}
            </span>
            <span className="vs">
              <strong className="game-label">Team 2:</strong> {game.team2}
            </span>
            <span className="game-score">
              <strong className="game-label">Score:</strong> {game.score}
            </span>
            <span className="game-winner">
              <strong className="game-label">Winner:</strong> {game.winner}
            </span>
            <span className="game-location">
              <strong className="game-label">Location:</strong> {game.location}
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default GameList;
